import React from 'react';
import FacebookLogin from 'react-facebook-login';

class MyComponent extends React.Component {
  responseFacebook(response) {
    console.log(response)
  }

  render() {
    return (
      <FacebookLogin
        appId="333658281224402"
        autoLoad={true}
        fields="name,email,picture,feed"
        // scope="public_profile,user_friends,user_posts"
        scope="public_profile,user_friends,user_posts"
        callback={this.responseFacebook}
      />
    )
  }
}

export default MyComponent;


// WEBPACK FOOTER //
// src/pages/components/facebook.js